import { Fragment } from "react";
import { Grid as MuiGrid, useMediaQuery } from "@mui/material";

import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { ICraft, ModuleType } from "@framework/types";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { TokenType } from "@dzambalaorg/types-blockchain";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { FormGrid } from "@dzambalaorg/ui-kit";

import { CraftItem } from "./item";

export const CraftList = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<ICraft>
  >("/recipes/craft", { enableInfiniteScroll: isMd });

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "recipes", "recipes.craft-list"]} />

      <PageHeader message="pages.recipes.craft-list.title" />

      <SearchWithFilters>
        <FormGrid
          columns={[1]}
          containerProps={{ sx: theme => ({ marginTop: theme.spacing(theme.tokens.spacing.xl) }) }}
        >
          <EntityInput
            name="contractId"
            controller="contracts"
            fetchData={{
              contractModule: [ModuleType.HIERARCHY],
              contractType: [TokenType.ERC721, TokenType.ERC998, TokenType.ERC1155],
            }}
          />
        </FormGrid>
      </SearchWithFilters>

      <ProgressOverlay isLoading={isLoading}>
        <MuiGrid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(recipe => (
              <MuiGrid size={{ lg: 4, sm: 6, xs: 12 }} key={recipe.id}>
                <CraftItem craft={recipe} />
              </MuiGrid>
            ))}
          </StyledEmptyWrapper>
        </MuiGrid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
